<div class="row">
	<div class="col-12">
		<data-table>
			<data-row>
				<custom-select [label]="'free-product-plan-setting.source-tag' | translate" [selectList]="selectListTags" [(value)]="setting.sourceTag" (valueChange)="valueChange()" [required]="true" />
			</data-row>
			<data-row>
				<custom-select [label]="'free-product-plan-setting.destination-tag' | translate" [selectList]="selectListTags" [(value)]="setting.destinationTag" (valueChange)="valueChange()" [required]="true" />
			</data-row>
			<data-row>
				<custom-input [label]="'free-product-plan-setting.amount' | translate" [inputType]="inputTypeEnum.Number" [(value)]="setting.amount" (valueChange)="valueChange()" [required]="true" />
			</data-row>
		</data-table>
	</div>
</div>
